var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 18,
    viewBox: "0 0 29 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.93692 3.51689C10.6662 -1.1723 18.3338 -1.1723 23.0631 3.51689L23.6323 4.08122C23.8687 4.31571 23.8687 4.69582 23.6323 4.9303L21.6853 6.86082C21.567 6.97806 21.3753 6.97806 21.2571 6.86082L20.4738 6.08424C17.1746 2.81292 11.8254 2.81292 8.52615 6.08424L7.68734 6.91588C7.56915 7.03313 7.37747 7.03313 7.25921 6.91588L5.31221 4.98537C5.07568 4.75088 5.07568 4.37077 5.31221 4.13629L5.93692 3.51689ZM27.0898 7.50945L28.8227 9.22758C29.0591 9.46207 29.0591 9.84217 28.8227 10.0767L21.0091 17.8242C20.7726 18.0586 20.3892 18.0586 20.1527 17.8242L14.6071 12.3256C14.5479 12.2669 14.4521 12.2669 14.393 12.3256L8.84749 17.8242C8.61103 18.0586 8.22761 18.0586 7.99116 17.8242L0.177347 10.0766C-0.0591158 9.8421 -0.0591158 9.46199 0.177347 9.2275L1.91022 7.5093C2.14668 7.27488 2.53007 7.27488 2.76653 7.5093L8.31227 13.008C8.37133 13.0667 8.46716 13.0667 8.5263 13.008L14.0717 7.5093C14.3082 7.27488 14.6916 7.27488 14.928 7.5093L20.4738 13.008C20.5329 13.0667 20.6287 13.0667 20.6879 13.008L26.2334 7.50945C26.47 7.27496 26.8533 7.27496 27.0898 7.50945Z",
    fill: "#3396FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnect);
export default __webpack_public_path__ + "static/media/walletconnect.d8f9b6b0d3151abf0441fa6975d1c99b.svg";
export { ForwardRef as ReactComponent };